import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ClipboardCheck, ExternalLink, Mail } from "lucide-react";
import { fmtDate } from "@/lib/format";
import { PageHeader, EmptyState } from "@/components/Page";

export default function Nachweise() {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get("/admin/confirmations").then((r) => setRows(r.data || []));
  }, []);

  return (
    <div>
      <PageHeader title="Nachweis-Archiv" subtitle="Alle unterschriebenen Durchführungsnachweise." testid="nachweise-header" />
      {rows.length === 0 ? (
        <Card className="border-slate-200 rounded-xl"><EmptyState icon={ClipboardCheck} title="Noch keine Nachweise" subtitle="Unterschriebene Aufträge erscheinen hier." testid="nachweise-empty" /></Card>
      ) : (
        <div className="grid gap-3">
          {rows.map((o) => (
            <Card key={o.id} className="p-4 border-slate-200 rounded-xl flex items-center justify-between gap-4" data-testid={`nachweis-${o.id}`}>
              <div>
                <div className="font-medium text-slate-900">{o.title}</div>
                <div className="text-sm text-slate-500">
                  {o.client_name} · Unterschrieben von {o.signed_by_name} · {fmtDate(o.signed_at)}
                  {o.confirmation_sent_at && <span className="inline-flex items-center gap-1 ml-2 text-emerald-600"><Mail className="h-3.5 w-3.5" /> versendet</span>}
                </div>
              </div>
              {o.confirmation_url && (
                <Button variant="outline" size="sm" asChild data-testid={`nachweis-open-${o.id}`}>
                  <a href={o.confirmation_url} target="_blank" rel="noreferrer">Öffnen <ExternalLink className="h-4 w-4 ml-1" /></a>
                </Button>
              )}
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
